import axios from 'components/Axios';
import { Reaction, ReplyReaction } from '../APIEndPoint';

const AddCommentReaction = (payload) => {
  const promise = axios.post(`${Reaction}`, payload);
  const dataPromise = promise.then((response) => response.data);
  return dataPromise;
};

const GetCommentReactionById = (payload) => {
  const promise = axios.get(`${Reaction}/byCommentId/${payload}/`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const RemoveCommentReactionById = (payload) => {
  const promise = axios.delete(`${Reaction}/${payload}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const AddReplyReaction = (payload) => {
  const promise = axios.post(`${ReplyReaction}`, payload);
  const dataPromise = promise.then((response) => response.data);
  return dataPromise;
};

const GetReplyReactionById = (payload) => {
  const promise = axios.get(`${ReplyReaction}/byReplyId/${payload}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const RemoveReplyReactionById = (payload) => {
  const promise = axios.delete(`${ReplyReaction}/${payload}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

export {
  AddCommentReaction,
  GetCommentReactionById,
  RemoveCommentReactionById,
  AddReplyReaction,
  GetReplyReactionById,
  RemoveReplyReactionById,
};
